import React, { Component } from 'react'
import styled from 'styled-components'
import { CommentsApi, ArticlesApi } from '../api'
import Comments from '../containers/Comments'
import Loader from '../components/Loader'
import ArticleHtml from '../containers/ArticleHtml'
import articles from '../data/articles.json'
import { Redirect } from 'react-router-dom'
import { media } from '../styles/vars'
import { virtualPush } from '../analytics'
import Header from '../components/Header'
import { interstitial, prerollTag } from '../ads'
import { push } from '../analytics'

const Container = styled.div`
background-color:#eaeaea;
min-height:100vh;
padding: 80px 8px 200px;
${
    media.desktop`
    padding: 80px 8px 200px;
    `
    }
`
const Content = styled.div`
margin:0 auto 40px;
${
    media.desktop`
    max-width:980px;
    `
    }
`
class Article extends Component {
    constructor(props) {
        super();
        this.setAllComments = this.setAllComments.bind(this);
        this.articleData = articles.find(article => article.id === props.match.params.id);
        this.commentsPerRequest = 10;
        this.state = this.getInitialState();
    }
    getInitialState() {
        return {
            articleHtml: '',
            showArticleLoader: true,
            comments: [],
            commentCount: 0,
            redirect: typeof this.articleData === 'undefined'
        };
    }
    async componentWillReceiveProps(props) {
        this.articleData = articles.find(article => article.id === props.match.params.id);
        this.setState(this.getInitialState());
        await this.initPage();
    }
    async componentDidMount() {
        await this.initPage();
    }
    async initPage() {
        if (!this.articleData) return;
        virtualPush(`/${this.articleData.id}`, this.articleData.title);
        interstitial();
        const _articleHtml = await ArticlesApi.get(this.articleData.id);

        const _comments = await CommentsApi.get(
            this.articleData.apiRef,
            this.commentsPerRequest
        )

        const _commentCount = await CommentsApi.getCount(this.articleData.apiRef);
        this.setState({
            comments: _comments,
            commentCount: _commentCount,
            articleHtml: _articleHtml,
            showMoreCommentsState: this.commentsPerRequest >= _commentCount ?
                "off" : "on",
            showArticleLoader: false
        });
        window.scrollTo(0, 0);

        if (this.articleData.videoId) {
            const details = await ArticlesApi.getVideoDetails(this.articleData.videoId);
            if (details && details.length)
                this.initVideo(details[0])
        }
    }
    initVideo(details) {
        window.flowplayer("#video", {
            key: '$509034830680622',
            splash: true,
            poster: details.poster_image,
            ratio: 9 / 16,
            share: false,
            cuepoints: [3],
            ima: {
                ads: [
                    {
                        time: 0,
                        adTag: prerollTag
                    }],
                locale: "he"
            },
            clip: {
                sources: [
                    {
                        type: "application/x-mpegurl",
                        src: details.desktop.replace("ynethd-i.akamaihd.net", "vod.ynet-cdnwiz.com")
                    },
                    {
                        type: "video/mp4",
                        src: details.mobile
                    }
                ]
            }
        }).on('cuepoint', () => {
            push('Video_Play', details.mobile);
        });
    }
    async setAllComments() {
        if (this.state.showMoreCommentsState === 'loading') return;
        this.setState({
            showMoreCommentsState: 'loading'
        });

        const _comments = await CommentsApi.get(this.articleData.apiRef);

        this.setState({
            comments: _comments,
            showMoreCommentsState: 'off'
        });
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={{ pathname: '/' }} />
            )
        }
        return (
            <Container>
                <Header
                    alwaysActive
                    showBackLink
                    noScroll
                />
                <Loader isActive={this.state.showArticleLoader} />
                <Content>
                    <ArticleHtml html={this.state.articleHtml} />
                    <Comments
                        comments={this.state.comments}
                        commentCount={this.state.commentCount}
                        showContainer={!this.state.showArticleLoader}
                        articleRef={this.articleData.apiRef}
                        onLoadMoreClick={this.setAllComments}
                        showMoreCommentsState={this.state.showMoreCommentsState}
                    />
                </Content>
            </Container>
        )
    }
}

export default Article;


// WEBPACK FOOTER //
// ./src/pages/Article.jsx